module.exports = ".table td, .table th {\r\n    border-left-width: 4px;\r\n    border-right-width: 4px;\r\n}\r\n"